<!--
Author: TangChen
Date: 2019-01-15
Desc: 我的私募资产组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-private-assets bizcomp ' + className">
        <comp-title :title="title" />
        <div class="private-con">
            <asset-fund ref="assetFund" :fund-info="privateInfo" :is-risk="0" v-on:fund-continue="fundCon" />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import assetFund from "@/components/fund/assetFund";
export default {
    name: "PrivateAssets",
    components: {
        assetFund
    },
    mixins: [mixin],
    data () {
        return {
            privateInfo: []
        };
    },
    mounted () {
        this.getPrivateAsset();
    },
    methods: {
        // 适当性基金信息校验
        fundCon (way, fund) {
            const _this = this;
            if (way === "20,22") {
                // 普通购买/定投
                fund.proto = "buy";
                this.$util.fundRiskCheck(this, fund, res => {
                    if (res) {
                        const _x = Object.assign({}, res, { way: way });
                        _this.$util.request("pef/trade/prdlist", { fundcode: fund.fundcode }).then(res => {
                            if (res.data) {
                                const _y = Object.assign({}, _x, res.data[0][0]);
                                sessionStorage.setItem("privatebuy", JSON.stringify(_y));
                                this.$router.push({ name: "privatebuy", query: { fundcode: res.fundcode } });
                            }
                        });
                    }
                });
            } else if (way === "24") {
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                this.$router.push({ name: "sellfund", query: { fundcode: _fund.fundcode } });
            }
        },
        // 查询持有私募基金资产
        getPrivateAsset () {
            this.$refs.assetFund.fundCate = "1";
            this.$util.request("pef/asset/detail").then(res => {
                if (res.data) {
                    this.privateInfo = this.$util.getCodeOnly(res.data, { code: "fundcode", noFilterVal: "1", data: ["marketvalue", "costmoney", "floatprofit", "appamount", "availablevol", "frozenvol", "balancevol"] });
                }
            });
        }
    }
};
</script>
